import React, {Component} from "react";
import "./UserEditProfileInfo.css";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";
import FormFieldValidationError from "../../../Common/FormFieldValidationError/FormFieldValidationError";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";

class UserEditProfileInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            userInfo: this.props.userInfo,
            userName: this.props.userInfo.username,
            name : this.props.userInfo.name,
            userEmail: this.props.userInfo.email,
            userContact: this.props.userInfo.phone,
            userAddress: this.props.userInfo.primaryAddress,
            japaneseFirstName : this.props.userInfo.japaneseFirstName,
            japaneseLastName : this.props.userInfo.japaneseLastName,
            firstName : this.props.userInfo.firstName,
            lastName : this.props.userInfo.lastName,
            nameValidationError: "",
            jpFnameValidationError: "",
            jpLnameValidationError: "",
            contactValidationError: "",
            addressValidationError: "",
            emailValidationError: "",

            showSuccess : false,
            showSuccessMsg : ""
        };

        this.getUserDetails= this.getUserDetails.bind(this);
        this.handleEditSuccessClose= this.handleEditSuccessClose.bind(this);
    }

    handleEditSuccessClose = () => {
      this.setState({
          showSuccess : false
      })
    };

    getUserDetails = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId, axiosConfig)
            .then((res) => {
                console.log("[user data new ====>: ", res.data);
                this.setState({
                    userName: res.data.username,
                    name: res.data.name,
                    firstName: res.data.firstName,
                    lastName: res.data.lastName,
                    userEmail: res.data.email,
                    userContact: res.data.phone,
                    userAddress: res.data.primaryAddress,
                    japaneseFirstName : res.data.japaneseFirstName,
                    japaneseLastName : res.data.japaneseLastName,
                    billingAddress : res.data.billingAddress,
                    billingAddressId : "-1",
                    shippingAddressId : "-1",
                    shippingAddress : res.data.shippingAddress,
                    userRole : res.data.userRole,
                    status : res.data.status
                });

                // console.log("USERRRRRRR DUO =====> ", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    handleClose = () => {
        this.setState({
            show: false,
            userName: this.props.userInfo.username,
            userContact: this.props.userInfo.phone,
            userAddress: this.props.userInfo.primaryAddress,
            userEmail: this.props.userInfo.email,
            nameValidationError: "",
            contactValidationError: "",
            addressValidationError: "",
            emailValidationError: "",
        });

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.validateName = this.validateName.bind(this);
        this.validateContact = this.validateContact.bind(this);
        this.validateAddress = this.validateAddress.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.updateProfileInfo = this.updateProfileInfo.bind(this);
    };

    handleShow = () => {
        this.setState({
            show: true
        },()=>this.getUserDetails());
    };

    validateName = (type, name) => {
        if (name === "") {
           if(type === 1){
               this.setState({
                   nameValidationError: "app.validation.user-profile.user-edit-profile.empty-name"
               });
           }else if(type === 2){
               this.setState({
                   jpFnameValidationError: "app.validation.user-profile.user-edit-profile.empty-name"
               });
           }else {
               this.setState({
                   jpLnameValidationError: "app.validation.user-profile.user-edit-profile.empty-name"
               });
           }
            return false;
        }
        return true;
    };

    validateContact = () => {
        let contact = this.state.userContact;
        let pattern = /^[0-9]*$/;
        if (contact === "") {
            this.setState({
                contactValidationError: "app.validation.user-profile.user-edit-profile.empty-contact"
            });
            return false;
        }
        return true;
    };

    validateAddress = () => {
        let address = this.state.userAddress;
        if (address === "") {
            this.setState({
                addressValidationError: "app.validation.user-profile.user-edit-profile.empty-address"
            });
            return false;
        }
        return true;
    };

    validateEmail = () => {
        let email = this.state.userEmail;
        let pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

        if (email === "" || !email.match(pattern)) {
            this.setState({
                emailValidationError: "app.validation.user-profile.user-edit-profile.empty-email"
            });
            return false;
        }
        return true;
    };

    updateProfileInfo = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.put(RESOURCE_BASE_URL + 'api/users/' + this.props.userInfo.id
            , {
                name: this.state.name,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.userEmail,
                phone: this.state.userContact,
                primaryAddress: this.state.userAddress,
                japaneseFirstName : this.state.japaneseFirstName,
                japaneseLastName : this.state.japaneseLastName,
                billingAddress : this.state.billingAddress,
                billingAddressId : "-1",
                shippingAddressId : "-1",
                shippingAddress : this.state.shippingAddress,
                userRole : this.state.userRole,
                status : this.state.status
            }, axiosConfig)
            .then((res) => {
                // console.log("User profile successfully updated", res);
                this.props.getUserDetails(this.props.userInfo.id);
                this.setState({
                    showSuccess : true,
                    showSuccessMsg : "プロファイルが正常に更新されました。"
                })
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({
                    showSuccess : true,
                    showSuccessMsg : "プロファイルの更新に失敗しました。"
                })
            });

    };

    onSubmit = event => {

        let nameOk = true;
        let contactOk = this.validateContact();
        let addressOk = this.validateAddress();
        // let emailOk = this.validateEmail();
        let emailOk = true;
        let jpFName = this.validateName(2,this.state.japaneseFirstName);
        let jpLName = this.validateName(3,this.state.japaneseLastName);

        if (nameOk && contactOk && addressOk && emailOk && jpFName && jpLName) {
            this.updateProfileInfo();
            // console.log("profile updated");
            this.handleClose();
        }

    };

    onInputChange = event => {
        // console.log("NAME DUO ==== >", event.target.name);
        this.setState({
            [event.target.name]: event.target.value,
            nameValidationError: "",
            contactValidationError: "",
            addressValidationError: "",
            emailValidationError: "",
            jpFnameValidationError: "",
            jpLnameValidationError: "",
        });
    };

    componentDidMount() {
        // console.log("JPFNAME DUO ===>", this.props.userInfo.japaneseFirstName);
        this.getUserDetails();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            console.log("user profile userInfo ===> " + this.props.userInfo);
            this.setState({userInfo: this.props.userInfo});
        }
    }


    render() {

        // console.log("USER INFO DUOaaaaaaaaaaaaaaaaaaaa =====> ",this.state );
        return (
            <div>
                <a className="edit-profile-link pull-right" onClick={this.handleShow}>
                    <FormattedMessage id="app.user-profile.user-profile-edit.button"
                                      defaultMessage="Update User Info"
                                      description=""/>
                    {/*ユーザー情報設定*/}
                </a>

                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            {/*<FormattedMessage id="app.user-profile.user-profile-edit.title"*/}
                                              {/*defaultMessage="UPDATE PROFILE"*/}
                                              {/*description=""/>*/}


                            ユーザー情報設定


                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="edit-profile-div color-text">
                            <div className="row">
                                <div className="no-padding col-md-2 text-right data-label">
                                    ユーザー名


                                </div>
                                <div className="col-md-9">
                                    {this.state.userName}

                                </div>
                            </div>
                            <div className="form-row-spacer"></div>
                            <div className="row">
                                <div className="no-padding col-md-2 text-right data-label">
                                    <FormattedMessage id="app.user-profile.user-profile-edit.email"
                                                      defaultMessage="Email"
                                                      description=""/>
                                </div>
                                <div className="col-md-9">
                                    {/*<input type="text" name="userEmail" value={this.state.userEmail}*/}
                                           {/*className="form-control input-sm" onChange={this.onInputChange}/>*/}

                                    {/*<FormFieldValidationError errors={this.state.emailValidationError}/>*/}
                                    {this.props.userInfo.email}

                                </div>
                            </div>

                            <div className="form-row-spacer"></div>

                            <div className="row">
                                <div className="no-padding col-md-2 text-right data-label">
                                    <FormattedMessage id="app.user-profile.user-profile-edit.phone"
                                                      defaultMessage="Phone"
                                                      description=""/>
                                </div>
                                <div className="col-md-9">
                                    <input type="text" name="userContact" value={this.state.userContact}
                                           className="form-control input-sm" onChange={this.onInputChange} maxLength={11}/>

                                    <FormFieldValidationError errors={this.state.contactValidationError}/>

                                </div>
                            </div>

                            <div className="form-row-spacer"></div>

                            <div className="row">
                                <div className="no-padding col-md-2 text-right data-label">
                                    {/*<FormattedMessage id="app.user-update.japanese-first-name "*/}
                                                      {/*defaultMessage="Japanese first name"*/}
                                                      {/*description=""/>*/}

                                    姓
                                </div>
                                <div className="col-md-9">
                                    <input type="text" name="japaneseLastName" value={this.state.japaneseLastName}
                                           className="form-control input-sm" onChange={this.onInputChange}/>

                                    <FormFieldValidationError errors={this.state.jpLnameValidationError}/>


                                </div>
                            </div>

                            <div className="form-row-spacer"></div>

                            <div className="row">
                                <div className="no-padding col-md-2 text-right data-label">
                                    名
                                </div>
                                <div className="col-md-9">
                                    <input type="text" name="japaneseFirstName" value={this.state.japaneseFirstName}
                                           className="form-control input-sm" onChange={this.onInputChange}/>

                                    <FormFieldValidationError errors={this.state.jpFnameValidationError}/>

                                </div>
                            </div>

                            {/*<div className="row">*/}
                                {/*<div className="no-padding col-md-3 text-right data-label">*/}
                                    {/*<FormattedMessage id="app.user-profile.user-profile-edit.address"*/}
                                                      {/*defaultMessage="Address"*/}
                                                      {/*description=""/>*/}
                                {/*</div>*/}
                                {/*<div className="col-md-9">*/}
                                    {/*<input type="text" name="userAddress" value={this.state.userAddress}*/}
                                           {/*className="form-control input-sm" onChange={this.onInputChange}/>*/}
                                    {/*<p id="example-txt">例:郵便番号 都道府県 市区町村 丁目番地号 マンション名部屋番号等</p>*/}
                                    {/*<FormFieldValidationError errors={this.state.addressValidationError}/>*/}

                                {/*</div>*/}
                            {/*</div>*/}

                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="edit-profile-div">
                            <button className="btn btn-primary bottom-button" onClick={this.onSubmit}>
                                <FormattedMessage id="app.user-profile.user-profile-edit.save"
                                                  defaultMessage="Save"
                                                  description=""/>

                            </button>
                            <a className="btn btn-default bottom-button" onClick={this.handleClose}>
                                <FormattedMessage id="app.user-profile.user-profile-edit.close"
                                                  defaultMessage="Close"
                                                  description=""/>

                            </a>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/*edit profile info success -----------------------*/}

                <Modal show={this.state.showSuccess}
                       onHide={this.handleEditSuccessClose} >
                    <Modal.Header closeButton
                                  onHide={this.handleEditSuccessClose}>
                        <div className="title-1 color-text">
                            更新プロファイル
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div>
                                {this.state.showSuccessMsg}
                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn col-md-2 pull-right btn-primary"
                                    onClick={this.handleEditSuccessClose}
                            >
                                閉じる
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>

            </div>

        )
    }

}

export default UserEditProfileInfo;



// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/UserEditProfileInfo/UserEditProfileInfo.js